<template>
  <el-dialog
    :append-to-body="true"
    :title="$t('declaracao-conteudo')"
    :visible.sync="dialog"
    :fullscreen="true"
    :close-on-click-modal="false"
    v-loading="loading"
  >
    <el-form>
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
          <el-form-item :label="$t('descricao')">
            <el-input ref="content" v-model="formDc.content" maxlength="100"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
          <el-form-item :label="$t('quantidade')">
            <el-input
              type="number"
              v-model="formDc.quantity"
              maxlength="5"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="5" :xl="7">
          <el-form-item :label="$t('valor')">
            <el-input type="number" v-model="formDc.value" maxlength="10">
              <el-button slot="append" type="default" @click="add()" v-if="!edition"
                >Adicionar</el-button
              >
              <el-button slot="append" type="success" @click="save()" v-if="edition"
                >Salvar</el-button
              >
              <el-button slot="append" type="default" @click="cancel()" v-if="edition"
                >Cancelar</el-button
              >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table
      :data="tableData"
      stripe
      ref="tableDc"
      style="width: 100%"
      :default-sort="{ prop: 'content', order: 'ascending' }"
    >
      <el-table-column prop="content" :label="$t('descricao')">
      </el-table-column>
      <el-table-column
        prop="quantity"
        :label="$t('quantidade')"
      ></el-table-column>
      <el-table-column prop="value" :label="$t('valor')">
        <template slot-scope="scope">{{
          scope.row.value
            | currency("R$ ", 2, {
              thousandsSeparator: ".",
              decimalSeparator: ",",
            })
        }}</template>
      </el-table-column>

      <el-table-column label="#" width="180">
        <template slot-scope="scope">
          <el-button
            type="info"
            icon="el-icon-edit"
            @click="edit(scope.$index, scope.row)"
            circle
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="remove(scope.$index)"
            circle
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="update()">Salvar</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { PrepostProductsService } from "@/services/customers/prepost.products.services";
import { i18n } from "@/plugin/i18n";
export default {
  name: "PrePostDCEdit",
  methods: {
    open(id) {
      this.id = id;
      this.dialog = true;
      this.fetchRecords();
    },
    edit(index, row) {
     const vm = this;
      vm.formDc.content = row.content;
      vm.formDc.id = row.id;
      vm.formDc.item = row.item;
      vm.formDc.value = row.value;
      vm.formDc.quantity = row.quantity;
      vm.current = index;
      vm.edition = true;
    },
    cancel() {
      const vm = this;
      this.edition = false;
      vm.formDc.id = "";
      vm.formDc.content = "";
      vm.formDc.value = 0;
      vm.formDc.quantity = 0;
    },
    save() {
      const vm = this;
      if (vm.current >= 0) {
        vm.tableData.splice(vm.current, 1, {
          id: vm.formDc.id,
          item: vm.formDc.item,
          content: vm.formDc.content,
          quantity: vm.formDc.quantity,
          value: vm.formDc.value,
        });
      vm.cancel();
    }
    },
    add() {
      const vm = this;
      if (!vm.formDc.content) {
        return vm.$message({
          type: "error",
          message: "Informe uma descrição!",
        });
      }
      const q = +vm.formDc.quantity;
      if (isNaN(q) || q <= 0) {
        return vm.$message({
          type: "error",
          message: "Informe uma quantidade valida!",
        });
      }
      const v = +vm.formDc.value;
      if (isNaN(v) || v <= 0) {
        return vm.$message({
          type: "error",
          message: "Informe um valor valido!",
        });
      }
      vm.tableData.push({
        id: '',
        item: vm.formDc.item,
        content: vm.formDc.content,
        quantity: vm.formDc.quantity,
        value: vm.formDc.value,
      });
      vm.formDc.id = "";
      vm.formDc.content = "";
      vm.formDc.value = 0;
      vm.formDc.quantity = 0;
      vm.formDc.item = vm.index;
      vm.index++;
      vm.$refs.content.$el.children[0].focus();
    },
    remove(index) {
      const vm = this;
      vm.tableData.splice(index, 1);
    },
    fetchRecords() {
      const vm = this;
      vm.loading = true;
      setTimeout(() => {
        PrepostProductsService.get(vm.id)
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => vm.loading = false);
      }, 200)
    },
    clear() {
      const vm = this;
      vm.tableData = [];
    },
    update() {
      const vm = this;
      vm.loading = true;
      PrepostProductsService.update(vm.id, vm.tableData)
      .then((response) => {
        vm.$message({
          type: "success",
          message: i18n.tc("declaracao-conteudo-sucesso"),
        });
        this.dialog = false;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
          duration: 5000,
        });
      })
      .finally(() => vm.loading = false);
    },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      dialog: false,
      edition: false,
      index: 1,
      current: -1,
      id: '',
      formDc: {
        id: '',
        item: 1,
        content: "",
        quantity: 0,
        value: 0,
      },
    };
  },
};
</script>
